import {createSlice} from "@reduxjs/toolkit";

const initialContestCategoriesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  html5GamesCategories: [],
  editContestCategory: [],
  deletedContestCategory: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const ContestCategoriesSlice = createSlice({
  
  name: "contestCategories",
  initialState: initialContestCategoriesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    contestCategoriesList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    contestCategoriesExport: (state, action) => {
      const { exportData } = action.payload;
      state.exportData = exportData;
    },
    html5GamesCategoriesList: (state, action) => {
      const { html5GamesCategories } = action.payload;
      state.html5GamesCategories = html5GamesCategories;
    },
    updateContestCategory: (state, action) => {
      const { editContestCategory } = action.payload;
      state.error = null;
      state.editContestCategory = editContestCategory;
    },
    deleteContestCategory: (state, action) => {
      const { deletedContestCategory } = action.payload;
      state.error = null;
      state.deletedContestCategory = deletedContestCategory;
    },
  }
});
